<div class="detail-content-block" fxLayout="column" fxLayoutAlign="start stretch" fxLayoutGap="10px">
	<ng-container *ngIf="resourceDetail?.description || resourceDetail?.infoFields?.experts?.length">
		<div class="detail-content-header" fxLayout="column" fxLayoutAlign="start stretch" fxLayoutGap="10px">
			<div fxLayout="column" fxLayoutAlign="start stretch" fxLayoutGap="20px">
				<div class="descrip-block">
					<app-readability [height]="(resourceDetail?.description) ? '275' : '40'">
						<content>
							<ng-container *ngIf="![null,undefined].includes(resourceDetail?.description)">
								<div [innerHtml]="resourceDetail?.description | safeDom"></div>
							</ng-container>
							<ng-container *ngIf="resourceDetail?.infoFields?.experts?.length">
								<div fxLayout="row wrap" fxLayoutAlign="start start" class="tag-experts-list">
									<ng-container
										*ngFor="let expert of resourceDetail?.infoFields?.experts; trackBy: gfService.trackByID.bind({'key': 'userID'})">
										<app-chips type="classic" [data]="{title: expert?.name, imageSrc: expert?.profilePicURL}"
											class="tag-expert-item">
										</app-chips>
									</ng-container>
								</div>
							</ng-container>
						</content>
					</app-readability>
				</div>
			</div>
		</div>
	</ng-container>
<ng-container *ngIf="resourceDetail?.resourceAction?.joinInAsking && !resourceDetail?.infoFields?.bestAnswer">
		<div fxLayout="row" fxLayoutAlign="center center" fxLayoutGap="20px">
			<div class="asking-info" fxLayout="row wrap" fxLayoutAlign="start center" fxLayoutAlign.xs="center center"
				fxLayoutGap="15px" fxLayoutGap.xs="15px">
				<p class="body-text" fxFlex="1 1">{{ locale.translate('looking_for_answers_text') }}</p>
				<div fxLayout="row" fxLayoutAlign="start center" fxLayoutGap="10px" class="button-block">
					<!-- <loader [loader]="loader" [type]="'general'"></loader> -->
					<button class="primary-btn" mat-stroked-button type="button" [disabled]="submitButtonDisable"
						(click)="joinAsking()">
						{{locale.translate('join_in_asking')}}
					</button>
					<!-- <ng-container *ngIf="!showJoinInAsking && resourceDetail?.resourceAction.closeQuestion">
					<button class="action-btn" mat-stroked-button type="button" [disabled]="submitButtonDisable"
						(click)="closeQuestion()">
						{{locale.translate('close_question')}}
					</button>
				</ng-container> -->
				</div>
			</div>
		</div>
	</ng-container>
	<div class="detail-content-body" fxLayout="column" fxLayoutAlign="start stretch" fxLayoutGap="20px">
		<div class="feature-placeholder fx-column fx-start-stretch"
			[ngStyle]="{'display': detectDevice?.resolutionState$?.value?.deviceType === 'mobile' ? 'block' : 'none'}">
		</div>
	</div>
</div>
<!-- <ng-container [ngTemplateOutlet]="feature"></ng-container> -->
